import "./index.scss";
import { useState, useEffect, useRef } from "react";
import {
  Input,
  Drawer,
  Button,
  Space,
  Radio,
  message,
  Checkbox,
  Select,
  DatePicker,
  TimePicker,
  Modal,
  Dropdown,
  Upload,
  Empty,
  Typography,
  Tooltip,
  notification
} from "antd";
import Api from "../../../../apis/index";
import {
  CloseOutlined,
  PlusOutlined,
  CloseCircleFilled,
  CalendarOutlined,
  GlobalOutlined,
  DeliveredProcedureOutlined,
  VerticalAlignBottomOutlined,
  LoadingOutlined,
  HolderOutlined,
  QuestionCircleFilled
} from "@ant-design/icons";
import MessageModal from "../../../../components/MessageModal/index";
import dayjs from "dayjs";
import { moonOptions, provinceMap, weekOptions } from "../../../../setting";
import xlsUrl from "../../../../assets/网络核查对象导入模板.xlsx";
import { useGetState, useSize } from "ahooks";
import emptyImg from "../../../../assets/暂无icon.png";
import { isCnNewID, isIncludeTimeEnhanced } from "../../../../unit/unit";
import { Virtuoso } from "react-virtuoso";
import {
  DndContext,
  closestCenter,
  PointerSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
  useSortable,
  arrayMove,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import AddAccountModal from "../../../../components/AddAccountModal";

const { Paragraph } = Typography;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

// 可拖拽排序的右侧网站条目
const SortableWebItem = ({ item, onRemove }) => {
  const { attributes, listeners, setNodeRef, transform, transition, isDragging } =
    useSortable({ id: item.id });
  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? 0.5 : 1,
  };
  return (
    <div ref={setNodeRef} style={style} className="sortableWebItem">
      <span className="dragHandle" {...attributes} {...listeners}>
        <HolderOutlined />
      </span>
      <Checkbox checked onChange={() => onRemove(item.id)} />
      <span className="sortableWebName">
        {item.web_name}
      </span>
    </div>
  );
};

const CreateDrawer = (props) => {
  const { isScheduledTask } = props;
  const [text, setText] = useState("");
  const [step, setStep] = useState(1);
  const [uploading, setUploading, getUploading] = useGetState(false);

  const [addObjectType, setAddObjectType] = useState(2);

  const [tableType, setTableType] = useState(1);

  const [legalPersonList, setLegalPersonList] = useState([]);
  const [naturalPersonList, setNaturalPersonList] = useState([]);

  const [checkWebsiteList, setCheckWebsiteList] = useState([]);
  const [webTabsActiveKey, setWebTabsActiveKey] = useState("");
  const [selectedWebList, setSelectedWebList] = useState([]);
  const [webSearchText, setWebSearchText] = useState("");

  const [watermarkWebHref, setWatermarkWebHref] = useState(true);
  const [watermarkObject, setWatermarkObject] = useState(true);
  const [watermarkTime, setWatermarkTime] = useState(true);
  const [watermarkSystemTime, setWatermarkSystemTime] = useState(true);
  const [watermarkVerifier, setWatermarkVerifier] = useState(false);
  const [watermarkVerifierText, setWatermarkVerifierText] = useState("");

  const [verifyPreviousNames, setVerifyPreviousNames] = useState(1);
  const [automaticReplenishment, setAutomaticReplenishment] = useState(1);
  const [reportScreenshotDisplayType, setReportScreenshotDisplayType] = useState(1);
  const [previewPath, setPreviewPath] = useState("");

  const [verificationType, setVerificationType] = useState(1);
  const [verifyTime, setVerifyTime] = useState([]);
  const [verifyTime2, setVerifyTime2] = useState(null);

  const [checkInterval, setCheckInterval] = useState("moon");
  const [checkIntervalIndex, setCheckIntervalIndex] = useState(1);
  const [checkIntervalTime, setCheckIntervalTime] = useState("02:00");

  const [frequentlyWebsiteGroupList, setFrequentlyWebsiteGroupList] = useState(
    []
  );
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [frequentlyWebsiteGroupName, setFrequentlyWebsiteGroupName] =
    useState(null);

  const [uploadFileLoading, setUploadFileLoading] = useState(false);
  const [inputHeight, setInputHeight] = useState(68);

  const [checkNumberObj , setCheckNumberObj, getCheckNumberObj] = useGetState({});

  const [ignoreWebList, setIgnoreWebList, getIgnoreWebList] = useGetState([]);

  const ref = useRef(null);
  const size = useSize(ref);

  const maxNumber = 2000;

  const legalPersonColumns = [
    {
      name: "企业名称",
      dataIndex: "name",
      key: "name",
      width: "346px",
    },
    {
      name: "所属地区",
      dataIndex: "area",
      key: "area",
      width: "162px",
      type: "select",
    },
  ];
  const naturalPersonColumns = [
    {
      name: "姓名",
      dataIndex: "name",
      key: "name",
      width: "80px",
    },
    {
      name:  <span>企业名称<Tooltip title="选填，仅用于自动匹配所属地区。"><QuestionCircleFilled style={{ cursor: 'help', fontSize: 14, marginLeft: 4 }} /></Tooltip></span>,
      dataIndex: "company",
      key: "company",
      width: "150px",
    },
    {
      name: "身份证号",
      dataIndex: "id_card",
      key: "id_card",
      width: "180px",
    },
    {
      name: "所属地区",
      dataIndex: "area",
      key: "area",
      width: "98px",
      type: "select",
    },
  ];

  // 清空所有
  const clearAll = () => {
    setStep(1);
    setText("");
    setAddObjectType(2);
    setTableType(1);
    setLegalPersonList([]);
    setNaturalPersonList([]);
    setWebTabsActiveKey("");
    setCheckWebsiteList([]);
    setSelectedWebList([]);
    setWebSearchText("");
    setWatermarkWebHref(true);
    setWatermarkObject(true);
    setWatermarkTime(true);
    setWatermarkSystemTime(true);
    setWatermarkVerifier(false);
    setWatermarkVerifierText("");
    setVerifyPreviousNames(1);
    setAutomaticReplenishment(1);
    setReportScreenshotDisplayType(1);
    setVerificationType(1);
    setVerifyTime([]);
    setVerifyTime2(null);
    setCheckInterval("moon");
    setCheckIntervalIndex(1);
    setCheckIntervalTime("02:00");
    setIsAddModalOpen(false);
    setFrequentlyWebsiteGroupName(null);
    setFrequentlyWebsiteGroupList([]);
    setTimeout(() => {
      setUploading(false);
    }, 500);
  };

  //去重 尽调对象 法人
  const removeDuplicateByName = (list) => {
    const seen = new Map();
    return list.filter((item) => {
      if (!seen.has(item.name)) {
        seen.set(item.name, true);
        return true;
      }
      return false;
    });
  };

  //判断 自然人是否有重复
  const hasInvalidDuplicates = (list) => {
    const nameMap = {};

    for (const item of list) {
      const name = item.name;

      if (!nameMap[name]) {
        nameMap[name] = [];
      }
      /*  
        先判断企业名称
        -> 如果都有值 不一样->通过 一样->判断身份证
        -> 如果一个有值一个没值 不通过
        -> 都没有值 判断身份证 
      */
      for (const existingItem of nameMap[name]) {
        const companyA = item.company || "";
        const companyB = existingItem.company || "";
        const idCardA = item.id_card || "";
        const idCardB = existingItem.id_card || "";

        // 公司一个有值一个没值 -> 不通过
        if ((companyA && !companyB) || (!companyA && companyB)) {
          return true;
        }

        // 公司都有值且不同 -> 通过
        if (companyA && companyB && companyA !== companyB) {
          continue;
        }

        // 身份证一个有值一个没值 -> 不通过
        if ((idCardA && !idCardB) || (!idCardA && idCardB)) {
          return true;
        }

        // 身份证都有值且不同 -> 通过
        if (idCardA && idCardB && idCardA !== idCardB) {
          continue;
        }

        // 其他情况都不通过
        return true;
      }

      nameMap[name].push(item);
    }

    return false;
  };

  // 移除单个
  const handleRemoveItem = (tableType, index) => {
    if (tableType === 1) {
      setLegalPersonList(legalPersonList.filter((_, i) => i !== index));
    } else if (tableType === 2) {
      setNaturalPersonList(naturalPersonList.filter((_, i) => i !== index));
    }
  };

  // 全部移除
  const handleRemoveAllItem = (tableType) => {
    if (tableType === 1) {
      setLegalPersonList([]);
    } else if (tableType === 2) {
      setNaturalPersonList([]);
    }
  };

  // 获取核查网站列表
  const getCheckWebsiteList = () => {
    Api.getCheckWebsiteList().then((res) => {
      if (res.code === 200) {
        let list = (res.data || []).sort((a, b) => a.seq - b.seq);
        setCheckWebsiteList(list);
        setWebTabsActiveKey(list?.[0]?.web_type || "");
        if (props.defaultSetting) {
          // 按 check_webs 原始顺序，从 API 列表中找到完整网站对象恢复已选列表
          const allWebsMap = {};
          list.forEach((group) => {
            (group.list || []).forEach((w) => {
              allWebsMap[w.id] = { ...w, web_type: group.web_type };
            });
          });
          const restored = [];
          (props.defaultSetting?.check_webs || []).forEach((item) => {
            if (allWebsMap[item.id]) {
              restored.push(allWebsMap[item.id]);
            }
          });
          setSelectedWebList(restored);
        }
      } else {
        message.error(res.message);
      }
    });
  };

  // 获取核查对象 解析接口
  const getVerifyTheCompanyByParse = () => {
    if (!text) {
      return;
    }
    if (
      legalPersonList.length >= maxNumber &&
      naturalPersonList.length >= maxNumber
    ) {
      message.warning(`核查对象已达上限${maxNumber * 2}个`);
      return;
    }
    let params = { input_str: text };
    Api.getVerifyTheCompany(params).then((res) => {
      if (res.code === 200) {
        let legalPersons = [];
        let naturalPersons = [];
        (res.data?.success || []).forEach((item) => {
          if (item.type === 1) {
            legalPersons.push(item);
          } else if (item.type === 2) {
            naturalPersons.push(item);
          }
        });
        let list1 = [...legalPersonList, ...legalPersons];
        list1 = removeDuplicateByName(list1);
        if (list1.length > maxNumber) {
          message.warning(`法人已达上限${maxNumber}个`);
          list1 = list1.slice(0, maxNumber);
        }
        setLegalPersonList(list1);
        let list2 = [...naturalPersonList, ...naturalPersons];
        if (list2.length > maxNumber) {
          message.warning(`自然人已达上限${maxNumber}个`);
          list2 = list2.slice(0, maxNumber);
        }
        setNaturalPersonList(list2);
        setText("");
      } else {
        message.error(res.message);
      }
    });
  };

  useEffect(()=>{
    setIgnoreWebList([])
  },[selectedWebList])

  // 下一步
  const nextStep = async () => {
    if (step === 1) {
      let total = legalPersonList.length + naturalPersonList.length;
      if (total === 0) {
        message.warning("请先添加核查对象");
        return;
      }
      let notHasArea = false;
      legalPersonList.forEach((item) => {
        if (item.area === null || item.area === undefined || item.area === "") {
          notHasArea = true;
        }
      });
      naturalPersonList.forEach((item) => {
        if (item.area === null || item.area === undefined || item.area === "") {
          notHasArea = true;
        }
      });
      let hasRepeat = hasInvalidDuplicates(naturalPersonList);
      if (hasRepeat) {
        message.warning("存在重复的姓名，请补充所属公司和身份证信息");
        return;
      }
      setIgnoreWebList([])
      if (notHasArea) {
        MessageModal({
          type: "warning",
          description: "未设置所属地区的核查对象将无法核查地区网站",
          message: "是否继续创建任务",
          title: "提醒",
          onOk: () => {
            setStep(2);
          },
        });
        return;
      }
    } else if (step === 2) {
      let total = selectedWebList.length;
      if (total === 0) {
        message.warning("请先添加核查网站");
        return;
      }

      const res = await Api.getAccountWebsiteOptions();
      const needAccountWebsite = res.data || [];
      const needAccountWebsiteList = selectedWebList.filter(item=>needAccountWebsite.some(item2=>{
        return item2.id === item.id && !getIgnoreWebList().some(item3=>item3.id === item2.id)
      }));
      if(needAccountWebsiteList.length > 0){
        const item = needAccountWebsiteList[0];
        AddAccountModal({
          title: "添加账号",
          itemInfo: item,
          onOk: () => {
            setStep(2);
            nextStep();
          },
          onCancel: () => {
            console.log(item,'111')
            setIgnoreWebList([...getIgnoreWebList(), item]);
            setStep(2);
            nextStep();
          }
        });
        return
      }
    }
    setIgnoreWebList([])
    setStep(step + 1);
  };

  // 标签页切换
  const webTabsChange = (key) => {
    setWebTabsActiveKey(key);
  };

  const getCurrentFilteredWebsites = () => {
    const currentGroup =
      checkWebsiteList.find((_) => _.web_type === webTabsActiveKey)?.list || [];
    if (!webSearchText) return currentGroup;
    const lowerSearch = webSearchText.toLowerCase();
    return currentGroup.filter((w) =>
      (w.web_name || "").toLowerCase().includes(lowerSearch)
    );
  };

  // 当前分类（过滤后）全选
  const onCheckAllChange = (checked) => {
    const currentList = getCurrentFilteredWebsites();
    if (checked) {
      const selectedIds = new Set(selectedWebList.map((w) => w.id));
      const toAdd = currentList
        .filter((w) => !selectedIds.has(w.id))
        .map((w) => ({ ...w, web_type: webTabsActiveKey }));
      setSelectedWebList((prev) => [...prev, ...toAdd]);
    } else {
      const currentListIds = new Set(currentList.map((w) => w.id));
      setSelectedWebList((prev) =>
        prev.filter((w) => !currentListIds.has(w.id))
      );
    }
  };

  // 当前分类（过滤后）全部取消
  const onCancelAllInCurrentTab = () => {
    const currentList = getCurrentFilteredWebsites();
    const currentListIds = new Set(currentList.map((w) => w.id));
    setSelectedWebList((prev) =>
      prev.filter((w) => !currentListIds.has(w.id))
    );
  };

  //核查时间变化
  const verifyTimeHandleChange = (date, dateString) => {
    setVerifyTime(dateString);
  };

  //核查时间变化
  const verifyTimeHandleChange2 = (date, dateString) => {
    setVerifyTime2(dateString);
  };

  // 单个网站勾选/取消
  const onSingleWebChange = (website, checked) => {
    if (checked) {
      setSelectedWebList((prev) => [
        ...prev,
        { ...website, web_type: webTabsActiveKey },
      ]);
    } else {
      setSelectedWebList((prev) => prev.filter((w) => w.id !== website.id));
    }
  };

  // 右侧列表移除单个
  const onRemoveFromSelected = (id) => {
    setSelectedWebList((prev) => prev.filter((w) => w.id !== id));
  };

  // 右侧列表全部取消
  const onClearAllSelected = () => {
    setSelectedWebList([]);
  };

  // 拖拽结束排序
  const onDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over?.id) {
      setSelectedWebList((prev) => {
        const oldIndex = prev.findIndex((w) => w.id === active.id);
        const newIndex = prev.findIndex((w) => w.id === over.id);
        return arrayMove(prev, oldIndex, newIndex);
      });
    }
  };

  // dnd-kit sensors
  const dndSensors = useSensors(useSensor(PointerSensor));

  //地区变化
  const areaChange = (index, key, value) => {
    if (tableType === 1) {
      setLegalPersonList((prev) => {
        prev = prev.map((_, _index) => {
          if (_index === index) {
            _[key] = value;
          }
          return _;
        });
        return [...prev];
      });
    } else {
      if (key === "id_card" && value) {
        if (!isCnNewID(value)) {
          message.warning("请输入正确的身份证号码");
          return;
        }
      }
      setNaturalPersonList((prev) => {
        prev = prev.map((_, _index) => {
          if (_index === index) {
            _[key] = value;
          }
          return _;
        });
        return [...prev];
      });
    }
  };

  //提交核查
  const verifySubmit = async () => {
    if (!props.open) {
      return;
    }
    if (getUploading()) {
      return;
    }
    if (watermarkVerifier && !watermarkVerifierText) {
      message.warning("请先输入核查人");
      return;
    }
    let check_objs = [];
    let check_webs = [];
    let watermark_config = {
      website_verification: watermarkWebHref,
      object_of_verification: watermarkObject,
      verification_time: watermarkTime,
      verification_system_time: watermarkSystemTime,
      verifier: watermarkVerifierText,
    };
    let check_rules = {
      watermark_config: watermark_config,
      check_former_name: verifyPreviousNames === 1,
      auto_fillcheck_wudao_data: automaticReplenishment === 1,
      report_screenshot_display_type: reportScreenshotDisplayType,
    };
    legalPersonList.forEach((_) => {
      _.check_type = 1;
      check_objs.push(_);
    });
    naturalPersonList.forEach((_) => {
      _.check_type = 2;
      check_objs.push(_);
    });
    selectedWebList.forEach((item) => {
      check_webs.push({ id: item.id });
    });

    let params = {
      check_objs,
      check_webs,
      check_rules,
      type: 1,
    };

    //定时任务核查
    if (isScheduledTask) {
      //单次核查
      if (verificationType === 1) {
        if (!verifyTime2) {
          message.warning("请先选择核查时间");
          return;
        }
        if (!checkIntervalTime) {
          message.warning("请先选择核查时间");
          return;
        }
        params.type = 2;
        params.start_date = verifyTime2;
        params.run_time = checkIntervalTime;
      } else {
        if (!verifyTime[0] && !verifyTime[1]) {
          message.warning("请先选择核查时间");
          return;
        }
        if (
          !isIncludeTimeEnhanced(
            verifyTime,
            checkInterval === "moon" ? "M" : "W",
            checkIntervalIndex
          )
        ) {
          message.warning("有效期内无可执行的时间点");
          return;
        }
        params.type = 3;
        params.start_date = verifyTime?.at(0);
        params.end_date = verifyTime?.at(1);
        params.period_type = checkInterval === "moon" ? "M" : "W";
        params.period_value = Number(checkIntervalIndex);
        params.run_time = checkIntervalTime;
      }
    }

    if (getCheckNumberObj()?.is_show) {
      setUploading(true);
      let res = await Api.obtainConsumption(params);
      let checkNumber = 0;
      if (res.code === 200) {
        checkNumber = res.data?.required_equity_point || 0;
      } else {
        message.error(res.message);
        setUploading(false);
        return;
      }
      if (checkNumber > (getCheckNumberObj()?.remaining_equity_point || 0)) {
        MessageModal({
          noIcon: true,
          notCancelBtn: true,
          description: (
            <span>
              任务需要消耗{checkNumber}核查权益点，当前权益点不足（剩余：
              {getCheckNumberObj()?.remaining_equity_point}）<br />
              如需更多核查权益，请联系商务。
            </span>
          ),
          message: (<>说明：消耗权益点=核查对象数量*核查网站数量<br></br>选择核查曾用名会增加核查对象数量</>),
          title: "提醒",
        });
        setUploading(false);
        return;
      }
    }
    let projectName = params.check_objs?.slice(0, 3).map(item => item.name).join('、')
    if(params.check_objs?.length > 3){
      projectName += `等`
    }
    let api = Api.createVerify;
    if (isScheduledTask && props?.defaultSetting?.id) {
      api = Api.editCronVerify;
      params.id = props?.defaultSetting?.id;
    }
    setUploading(true);
    api(params)
      .then((res) => {
        if (res.code === 200) {
          props.successFunc && props.successFunc();
          message.success(res.message);
          notification.info({
            message: `项目【${projectName}】核查已启动，完成后将短信通知您。`,
            placement: 'bottomRight'
          });
        } else {
          message.error(res.message);
          setUploading(false);
        }
      })
      .catch(() => {
        setUploading(false);
      });
  };

  //创建常用网站
  const addFrequentlyWebsite = () => {
    if (selectedWebList.length === 0) {
      message.warning("请先添加核查网站");
      return;
    }
    setIsAddModalOpen(true);
  };

  const addFrequentlyWebsiteHandle = () => {
    if (!frequentlyWebsiteGroupName) {
      message.warning("请先输入分组名称");
      return;
    }
    const check_webs = selectedWebList.map((item) => ({ id: item.id }));
    let params = {
      check_webs,
      name: frequentlyWebsiteGroupName,
    };
    Api.addFrequentlyWebsite(params).then((res) => {
      if (res.code === 200) {
        getFrequentlyWebsite();
        setIsAddModalOpen(false);
        setFrequentlyWebsiteGroupName(null);
        message.success(res.message);
      } else {
        message.error(res.message);
      }
    });
  };

  //删除常用网站
  const deleteFrequentlyWebsite = (item) => {
    MessageModal({
      type: "warning",
      description: "确定要删除此条数据吗？",
      title: "删除",
      onOk: () => {
        Api.deleteFrequentlyWebsite(item.id).then((res) => {
          if (res.code === 200) {
            message.success(res.message);
            getFrequentlyWebsite();
          } else {
            message.error(res.message);
          }
        });
      },
    });
  };

  //获取常用网站
  const getFrequentlyWebsite = () => {
    Api.getFrequentlyWebsite().then((res) => {
      if (res.code === 200) {
        setFrequentlyWebsiteGroupList(res.data || []);
      } else {
        message.error(res.message);
        setFrequentlyWebsiteGroupList([]);
      }
    });
  };

  //使用常用网站
  const useFrequentlyWebsiteGroup = (info) => {
    const item = frequentlyWebsiteGroupList.find(
      (_) => _.id === Number(info.key)
    );
    if (item?.check_webs) {
      // 新结构: check_webs 是 [{ id: 153 }, ...] 数组
      const allWebsMap = {};
      checkWebsiteList.forEach((group) => {
        (group.list || []).forEach((w) => {
          allWebsMap[w.id] = { ...w, web_type: group.web_type };
        });
      });
      const restored = [];
      (item.check_webs || []).forEach((web) => {
        if (allWebsMap[web.id]) {
          restored.push(allWebsMap[web.id]);
        }
      });
      setSelectedWebList(restored);
    }
  };

  //下载模版
  const downloadTemplate = () => {
    let link = document.createElement("a");
    link.style.display = "none";
    let title = "";
    link.href = xlsUrl;
    title = "网络核查对象导入模板.xlsx";
    link.setAttribute("download", title);
    link.target = "_blank";
    document.body.appendChild(link);
    link.click();
    link.remove();
  };

  // 上传文件
  const uploadFile = (info) => {
    const formData = new FormData();
    formData.append("file[]", info.file?.originFileObj);
    setUploadFileLoading(true);
    Api.getVerifyTheCompanyByFile(formData)
      .then((res) => {
        if (res.code === 200) {
          let legalPersons = [];
          let naturalPersons = [];
          (res.data?.success || []).forEach((item) => {
            if (item.type === 1) {
              legalPersons.push(item);
            } else if (item.type === 2) {
              naturalPersons.push(item);
            }
          });
          let list1 = [...legalPersonList, ...legalPersons];
          list1 = removeDuplicateByName(list1);
          if (list1.length > maxNumber) {
            message.warning(`法人已达上限${maxNumber}个`);
            list1 = list1.slice(0, maxNumber);
          }
          setLegalPersonList(list1);
          let list2 = [...naturalPersonList, ...naturalPersons];
          if (list2.length > maxNumber) {
            message.warning(`自然人已达上限${maxNumber}个`);
            list2 = list2.slice(0, maxNumber);
          }
          setNaturalPersonList(list2);
        } else {
          message.error(res.message);
        }
        setUploadFileLoading(false);
      })
      .catch(() => {
        setUploadFileLoading(false);
      });
  };

  const getCheckNumber = () => {
    Api.getEquityPointsFunc().then((res) => {
      if (res.code === 200) {
        let obj = res.data || {};
        obj.is_show = true;
        setCheckNumberObj(obj);
        // TODO:  什么时候提示
        let is_show = obj.is_show;
        if (is_show) {
          MessageModal({
            noIcon: true,
            notCancelBtn: true,
            description: (
              <span>
                共{res.data?.sum_topup_equity_point}权益点（剩余：
                {res.data?.remaining_equity_point}）<br />
                如需更多核查权益，请联系商务。
              </span>
            ),
            message: (<>说明：消耗权益点=核查对象数量*核查网站数量<br></br>选择核查曾用名会增加核查对象数量</>),
            title: "提醒",
          });
        }
      } else {
        setCheckNumberObj({});
        message.error(res.message);
      }
    });
  };

  useEffect(() => {
    // 从 localStorage 获取预览图路径
    const previewPath = localStorage.getItem("preview_path") || "";
    setPreviewPath(previewPath);

    if (!props.open) {
      clearAll();
      return;
    }
    //获取核查数量
    getCheckNumber();
    getCheckWebsiteList();
    getFrequentlyWebsite();
    if (props.defaultSetting) {
      let defaultSetting = props.defaultSetting;
      //阶段1
      let legalPersonList = [],
        naturalPersonList = [];
      (defaultSetting?.check_objs || []).forEach((item) => {
        if (item.check_type === "1") {
          legalPersonList.push({
            name: item.target_name,
            area: item.area || null,
            company_id: item.company_id || null,
          });
        } else {
          naturalPersonList.push({
            name: item.target_name,
            company: item.company || "",
            area: item.area || null,
            id_card: item.id_card || "",
          });
        }
      });
      legalPersonList = removeDuplicateByName(legalPersonList);
      setLegalPersonList(legalPersonList);
      setNaturalPersonList(naturalPersonList);
      //阶段3
      setWatermarkWebHref(
        defaultSetting?.check_rules?.watermark_config?.website_verification ||
          false
      );
      setWatermarkObject(
        defaultSetting?.check_rules?.watermark_config?.object_of_verification ||
          false
      );
      setWatermarkTime(
        defaultSetting?.check_rules?.watermark_config?.verification_time ||
          false
      );
      setWatermarkSystemTime(
        defaultSetting?.check_rules?.watermark_config
          ?.verification_system_time || false
      );
      setWatermarkVerifier(
        defaultSetting?.check_rules?.watermark_config?.verifier ? true : false
      );
      setWatermarkVerifierText(
        defaultSetting?.check_rules?.watermark_config?.verifier || ""
      );
      setVerifyPreviousNames(
        defaultSetting?.check_rules?.check_former_name ? 1 : 2
      );
      setAutomaticReplenishment(
        defaultSetting?.check_rules?.auto_fillcheck_wudao_data ? 1 : 2
      );
      setReportScreenshotDisplayType(
        defaultSetting?.check_rules?.report_screenshot_display_type || 1
      );
      //单次核查
      if (defaultSetting?.check_cron_info?.type === 2) {
        setVerificationType(1);
        setVerifyTime2(defaultSetting?.check_cron_info?.start_date);
        setCheckIntervalTime(defaultSetting?.check_cron_info?.run_time || null);
      }
      //周期核查
      if (defaultSetting?.check_cron_info?.type === 3) {
        setVerificationType(2);
        setVerifyTime([
          defaultSetting?.check_cron_info?.start_date || null,
          defaultSetting?.check_cron_info?.end_date || null,
        ]);
        setCheckInterval(
          defaultSetting?.check_cron_info?.period_type === "M" ? "moon" : "week"
        );
        setCheckIntervalIndex(
          defaultSetting?.check_cron_info?.period_value || 1
        );
        setCheckIntervalTime(defaultSetting?.check_cron_info?.run_time || null);
      }
      // console.log(defaultSetting, webCheckObj);
    }
    // 这里刻意只在抽屉 open 变化时触发初始化逻辑
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.open]);

  return (
    <Drawer
      title={isScheduledTask ? "创建定时任务" : "创建核查任务"}
      width={600}
      closable={false}
      onClose={props.onClose}
      open={props.open}
      className="myDrawer"
      extra={<CloseOutlined onClick={props.onClose} />}
      footer={
        <Space size="middle" align="center" direction="horizontal">
          <Button onClick={props.onClose} disabled={uploading}>
            取消
          </Button>
          {step !== 1 && (
            <Button onClick={() => setStep(step - 1)} disabled={uploading}>
              上一步
            </Button>
          )}
          {step !== 3 ? (
            <Button
              type="primary"
              onClick={() => nextStep()}
              disabled={uploading}
            >
              下一步
            </Button>
          ) : (
            <Button
              type="primary"
              loading={uploading}
              disabled={uploading}
              onClick={() => verifySubmit()}
            >
              立即核查
            </Button>
          )}
        </Space>
      }
    >
      <div className="createDrawerContent" ref={ref}>
        <div className="stepBox">
          {["添加核查对象", "选择核查网站", "设置核查规则"].map(
            (item, index) => (
              <div
                className={
                  index + 1 === step ? "stepItem activeStepItem" : "stepItem"
                }
                key={index}
              >
                <div className="line"></div>
                <span>{item}</span>
              </div>
            )
          )}
        </div>
        <div className="stepContent">
          {/* 第一阶段 */}
          {step === 1 && (
            <div>
              <div class="headerTitleContent">
                <div class="left">
                  <span class="block"></span>
                  <div class="title">
                    <div class="commentsHeaderTitleBox">核查对象</div>
                  </div>
                  <div className="dividerLine"></div>
                  <span className="text">
                    已添加 {legalPersonList.length + naturalPersonList.length}{" "}
                    个
                  </span>
                </div>
                <div class="right"> </div>
              </div>
              <div className="stepContentBox">
                {/* <Radio.Group
                  buttonStyle="solid"
                  size="middle"
                  value={addObjectType}
                  onChange={(e) => {
                    setText("");
                    setAddObjectType(e.target.value);
                  }}
                >
                  <Radio.Button value={1}>智能添加</Radio.Button>
                  <Radio.Button value={2}>自助添加</Radio.Button>
                </Radio.Group> */}
                <div className="addObjectInputBox">
                  {addObjectType === 1 && (
                    <TextArea
                      rows={4}
                      placeholder="请输入核查对象"
                      className="addObjectTextArea"
                      value={text}
                      onChange={(e) => setText(e.target.value)}
                    />
                  )}
                  {addObjectType === 2 && (
                    <TextArea
                      className="addObjectTextArea"
                      placeholder={`请输入核查主体名称，自然人需要补充所属公司、身份证信息用空格分割\n支持批量粘贴主体名称，请用换行隔开（最多100个）\n示例：\n宁德时代新能源科技股份有限公司\n罗源时代新能源科技有限公司 福建省\n李平\n蒋理 宁德时代新能源科技股份有限公司\n曾毓群 宁德时代新能源科技股份有限公司 3509************** 福建省`}
                      value={text}
                      title={`请输入核查主体名称，自然人需要补充所属公司、身份证信息用空格分割\n支持批量粘贴主体名称，请用换行隔开（最多100个）\n示例：\n宁德时代新能源科技股份有限公司\n罗源时代新能源科技有限公司 福建省\n李平\n蒋理 宁德时代新能源科技股份有限公司\n曾毓群 宁德时代新能源科技股份有限公司 3509************** 福建省`}
                      onChange={(e) => setText(e.target.value)}
                      style={{ height: inputHeight + "px" }}
                      onFocus={() => {
                        setInputHeight(162);
                      }}
                      onBlur={() => {
                        setInputHeight(68);
                      }}
                    />
                  )}
                  <div
                    className="addObjectBtnBox"
                    onClick={() => {
                      getVerifyTheCompanyByParse();
                    }}
                  >
                    <PlusOutlined />
                    添加
                  </div>
                </div>
                <div className="tipsBtnBox">
                  {uploadFileLoading ? (
                    <span className="tipsItem">
                      <LoadingOutlined style={{ marginRight: "4px" }} />
                      文件解析中
                    </span>
                  ) : (
                    <Upload
                      fileList={[]}
                      name="file"
                      multiple={false}
                      onChange={(info) => {
                        if (
                          legalPersonList.length >= maxNumber &&
                          naturalPersonList.length >= maxNumber
                        ) {
                          message.warning(`核查对象已达上限${maxNumber * 2}个`);
                          return;
                        }
                        uploadFile(info);
                      }}
                      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    >
                      <span className="tipsItem">
                        <PlusOutlined />
                        批量上传
                      </span>
                    </Upload>
                  )}

                  <span className="tipsItem" onClick={() => downloadTemplate()}>
                    <VerticalAlignBottomOutlined />
                    下载模版
                  </span>
                </div>
                <div className="exampleBox">
                  <div className="objectTypeBox">
                    <span
                      className={tableType === 1 ? "activeSpan" : ""}
                      onClick={() => {
                        setTableType(1);
                      }}
                    >
                      法人（{legalPersonList.length}）
                    </span>
                    <span
                      className={tableType === 2 ? "activeSpan" : ""}
                      onClick={() => {
                        setTableType(2);
                      }}
                    >
                      自然人（{naturalPersonList.length}）
                    </span>
                    <span onClick={() => handleRemoveAllItem(tableType)}>
                      全部移除
                    </span>
                  </div>
                  <div className="objectTable">
                    <div className="objectTableHeader">
                      {(tableType === 1
                        ? legalPersonColumns
                        : naturalPersonColumns
                      ).map((item) => (
                        <div className="objectTh" style={{ width: item.width }}>
                          {item.name}
                        </div>
                      ))}
                    </div>
                    {(tableType === 1 ? legalPersonList : naturalPersonList)
                      ?.length === 0 ? (
                      <div
                        className="emptyItemBox"
                        style={{ width: tableType === 1 ? "508px" : "508px" }}
                      >
                        <Empty image={emptyImg} description="暂无数据"></Empty>
                      </div>
                    ) : (
                      // (tableType === 1
                      //   ? legalPersonList
                      //   : naturalPersonList
                      // ).map((item, index) => (
                      //   <div className="objectTableRow">
                      //     {(tableType === 1
                      //       ? legalPersonColumns
                      //       : naturalPersonColumns
                      //     ).map((column) => (
                      //       <div
                      //         className="objectTd"
                      //         style={{ width: column.width }}
                      //       >
                      //         {column?.type !== "select" ? (
                      //           tableType === 1 ? (
                      //             item[column.dataIndex] || ""
                      //           ) : (
                      //             <Paragraph
                      //               editable={{
                      //                 onChange: (value) => {
                      //                   areaChange(
                      //                     index,
                      //                     column.dataIndex,
                      //                     value
                      //                   );
                      //                 },
                      //                 // editing: true,
                      //               }}
                      //             >
                      //               {item[column.dataIndex] || ""}
                      //             </Paragraph>
                      //           )
                      //         ) : (
                      //           <Select
                      //             variant="borderless"
                      //             value={item[column.dataIndex]}
                      //             style={{ width: "100%" }}
                      //             onChange={(value) => {
                      //               areaChange(index, column.dataIndex, value);
                      //             }}
                      //             options={provinceMap}
                      //           />
                      //         )}
                      //       </div>
                      //     ))}
                      //     <CloseCircleFilled
                      //       onClick={() => handleRemoveItem(tableType, index)}
                      //     />
                      //   </div>
                      // ))
                      <Virtuoso
                        style={{
                          height:
                            (size?.height - (200 + inputHeight) || 400) + "px",
                        }}
                        totalCount={
                          (tableType === 1
                            ? legalPersonList
                            : naturalPersonList
                          )?.length
                        }
                        itemContent={(index) => {
                          const item = (
                            tableType === 1
                              ? legalPersonList
                              : naturalPersonList
                          )[index];
                          return (
                            <div className="objectTableRow">
                              {(tableType === 1
                                ? legalPersonColumns
                                : naturalPersonColumns
                              ).map((column) => (
                                <div
                                  className="objectTd"
                                  style={{ width: column.width }}
                                >
                                  {column?.type !== "select" ? (
                                    tableType === 1 ? (
                                      item[column.dataIndex] || ""
                                    ) : (
                                      <Paragraph
                                        editable={{
                                          onChange: (value) => {
                                            areaChange(
                                              index,
                                              column.dataIndex,
                                              value
                                            );
                                          },
                                          // editing: true,
                                        }}
                                      >
                                        {item[column.dataIndex] || ""}
                                      </Paragraph>
                                    )
                                  ) : (
                                    <Select
                                      variant="borderless"
                                      value={item[column.dataIndex]}
                                      style={{ width: "100%" }}
                                      onChange={(value) => {
                                        areaChange(
                                          index,
                                          column.dataIndex,
                                          value
                                        );
                                      }}
                                      options={provinceMap}
                                    />
                                  )}
                                </div>
                              ))}
                              <CloseCircleFilled
                                onClick={() =>
                                  handleRemoveItem(tableType, index)
                                }
                              />
                            </div>
                          );
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* 第二阶段 */}
          {step === 2 && (
            <div style={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <div className="headerTitleContent">
                <div className="left">
                  <span className="block"></span>
                  <div className="title">
                    <div className="commentsHeaderTitleBox">核查网站</div>
                  </div>
                  <div className="dividerLine"></div>
                  <span className="text">
                    已选择 {selectedWebList.length} 个
                  </span>
                </div>
                <div className="right">
                  <span className="rightIconSpan">
                    <Dropdown
                      menu={{
                        items: frequentlyWebsiteGroupList.map((_) => ({
                          key: _.id,
                          label: (
                            <span
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                userSelect: "none",
                              }}
                            >
                              {_.name}
                              <CloseOutlined
                                className="rightIconSpanDropdownDeleteIcon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  deleteFrequentlyWebsite(_);
                                }}
                              />
                            </span>
                          ),
                        })),
                        onClick: useFrequentlyWebsiteGroup,
                      }}
                    >
                      <span>
                        <GlobalOutlined />
                        常用核查网站
                      </span>
                    </Dropdown>
                  </span>
                  <span
                    className="rightIconSpan"
                    onClick={() => addFrequentlyWebsite()}
                  >
                    <DeliveredProcedureOutlined />
                    保存为常用
                  </span>
                </div>
              </div>
              <div className="websiteSelectLayout" style={{ display: "flex", gap: "12px", marginTop: "14px", flex: 1, minHeight: 0 }}>
                {/* 左侧：可选择网站 */}
                <div className="websiteLeftPanel" style={{ flex: 1, display: "flex", flexDirection: "column", border: "1px solid rgba(0,104,178,0.15)", borderRadius: "6px", overflow: "hidden", minHeight: 0 }}>
                  <div className="websiteLeftTitle" style={{ fontSize: "13px", fontWeight: 600, color: "#333", padding: "8px 12px 6px", borderBottom: "1px solid rgba(0,104,178,0.1)", flexShrink: 0 }}>可选择网站</div>
                  <Input
                    className="websiteSearchInput"
                    style={{ margin: "8px 12px", width: "calc(100% - 24px)", flexShrink: 0 }}
                    placeholder="输入网站名称搜索"
                    value={webSearchText}
                    onChange={(e) => setWebSearchText(e.target.value)}
                    allowClear
                  />
                  <div className="websiteSplitLayout" style={{ display: "flex", flex: 1, overflow: "hidden", borderTop: "1px solid rgba(0,104,178,0.1)" }}>
                    {/* 分类列表 */}
                    <div className="categoryList" style={{ width: "96px", flexShrink: 0, overflowY: "auto", borderRight: "1px solid rgba(0,104,178,0.1)", background: "rgba(0,104,178,0.02)" }}>
                      {checkWebsiteList.map((group) => {
                        const selectedCount = selectedWebList.filter(
                          (w) => w.web_type === group.web_type
                        ).length;
                        const total = (group.list || []).length;
                        const filteredTotal = webSearchText
                          ? (group.list || []).filter(
                              (w) => w.web_name.toLowerCase().includes(webSearchText.toLowerCase())
                            ).length
                          : total;
                        return (
                          <div
                            key={group.web_type}
                            className={
                              webTabsActiveKey === group.web_type
                                ? "categoryItem activeCategoryItem"
                                : "categoryItem"
                            }
                            onClick={() => webTabsChange(group.web_type)}
                          >
                            <span className="categoryName">{group.web_type}</span>
                            <span className="categoryCount">
                              {webSearchText ? `${selectedCount}/${filteredTotal}` : `${selectedCount}/${total}`}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                    {/* 网站 checkbox 列表 */}
                    <div className="websiteCheckList" style={{ flex: 1, overflowY: "auto", padding: "8px 12px", display: "flex", flexDirection: "column" }}>
                      {(() => {
                        const currentGroup = checkWebsiteList.find(
                          (_) => _.web_type === webTabsActiveKey
                        );
                        const currentList = (currentGroup?.list || []).filter(
                          (w) =>
                            !webSearchText ||
                            w.web_name
                              .toLowerCase()
                              .includes(webSearchText.toLowerCase())
                        );
                        const selectedIds = new Set(
                          selectedWebList.map((w) => w.id)
                        );
                        const allChecked =
                          currentList.length > 0 &&
                          currentList.every((w) => selectedIds.has(w.id));
                        const indeterminate =
                          !allChecked &&
                          currentList.some((w) => selectedIds.has(w.id));
                        return (
                          <>
                            {webTabsActiveKey?.includes("地区网站") && (
                              <div className="tipsSpan">
                                提醒：地区网站根据核查主体所属地区自动匹配网址，如未设置所属地区则无法核查该对象
                              </div>
                            )}
                            <div className="checkListHeader">
                              <Checkbox
                                indeterminate={indeterminate}
                                checked={allChecked}
                                onChange={(e) =>
                                  onCheckAllChange(e.target.checked)
                                }
                              >
                                全选
                              </Checkbox>
                              <span
                                className="cancelAllBtn"
                                onClick={onCancelAllInCurrentTab}
                              >
                                全部取消
                              </span>
                            </div>
                            <div className="checkboxItems">
                              {currentList.map((website) => (
                                <div
                                  key={website.id}
                                  className="checkboxItem"
                                >
                                  <Checkbox
                                    checked={selectedIds.has(website.id)}
                                    onChange={(e) =>
                                      onSingleWebChange(
                                        website,
                                        e.target.checked
                                      )
                                    }
                                  >
                                    {(() => {
                                      const webName = website.web_name;
                                      if (!webSearchText) {
                                        return website.source === "自助添加" ? (
                                          <span className="zztjSpan">{webName}</span>
                                        ) : (
                                          webName
                                        );
                                      }
                                      const lowerName = webName.toLowerCase();
                                      const lowerSearch = webSearchText.toLowerCase();
                                      const index = lowerName.indexOf(lowerSearch);
                                      if (index === -1) {
                                        return website.source === "自助添加" ? (
                                          <span className="zztjSpan">{webName}</span>
                                        ) : (
                                          webName
                                        );
                                      }
                                      const before = webName.slice(0, index);
                                      const match = webName.slice(index, index + webSearchText.length);
                                      const after = webName.slice(index + webSearchText.length);
                                      const content = (
                                        <>
                                          {before}
                                          <span style={{ color: "#0068b7", fontWeight: 600 }}>{match}</span>
                                          {after}
                                        </>
                                      );
                                      return website.source === "自助添加" ? (
                                        <span className="zztjSpan">{content}</span>
                                      ) : (
                                        content
                                      );
                                    })()}
                                  </Checkbox>
                                </div>
                              ))}
                              {currentList.length === 0 && (
                                <div className="emptyTip">暂无匹配网站</div>
                              )}
                            </div>
                            <div className="tipsSpan2">*自主添加的核查网站</div>
                          </>
                        );
                      })()}
                    </div>
                  </div>
                </div>
                {/* 右侧：已选择网站 */}
                <div className="websiteRightPanel" style={{ width: "200px", flexShrink: 0, display: "flex", flexDirection: "column", border: "1px solid rgba(0,104,178,0.15)", borderRadius: "6px", overflow: "hidden", minHeight: 0 }}>
                  <div className="rightPanelHeader" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "8px 12px 6px", borderBottom: "1px solid rgba(0,104,178,0.1)", flexShrink: 0 }}>
                    <span className="rightPanelTitle">
                      已选择网站
                      <span className="rightPanelCount">
                        （{selectedWebList.length}个）
                      </span>
                    </span>
                    <span
                      className="cancelAllBtn"
                      onClick={onClearAllSelected}
                    >
                      全部取消
                    </span>
                  </div>
                  <div className="rightPanelTip" style={{ fontSize: "11px", color: "#9E9E9E", padding: "5px 12px", flexShrink: 0, borderBottom: "1px solid rgba(0,104,178,0.08)" }}>
                    *拖拽可调整核查报告中网站顺序
                  </div>
                  <div className="sortableList" style={{ flex: 1, overflowY: "auto", padding: "6px 0" }}>
                    <DndContext
                      sensors={dndSensors}
                      collisionDetection={closestCenter}
                      onDragEnd={onDragEnd}
                    >
                      <SortableContext
                        items={selectedWebList.map((w) => w.id)}
                        strategy={verticalListSortingStrategy}
                      >
                        {selectedWebList.map((item) => (
                          <SortableWebItem
                            key={item.id}
                            item={item}
                            onRemove={onRemoveFromSelected}
                          />
                        ))}
                      </SortableContext>
                    </DndContext>
                    {selectedWebList.length === 0 && (
                      <div className="emptyTip">暂未选择网站</div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}
          {/* 第三阶段 */}
          {step === 3 && (
            <div>
              <div class="headerTitleContent">
                <div class="left">
                  <span class="block"></span>
                  <div class="title">
                    <div class="commentsHeaderTitleBox">核查规则</div>
                  </div>
                </div>
              </div>
              <div className="stepContentBox">
                <div className="ruleItem">
                  <div className="ruleItemTitle">核查水印</div>
                  <div className="ruleItemBox">
                    <Checkbox
                      checked={watermarkWebHref}
                      onChange={(e) => {
                        setWatermarkWebHref(e.target.checked);
                      }}
                    >
                      网站核查
                    </Checkbox>
                    <Checkbox
                      checked={watermarkObject}
                      onChange={(e) => {
                        setWatermarkObject(e.target.checked);
                      }}
                    >
                      核查对象
                    </Checkbox>
                    <Checkbox
                      checked={watermarkTime}
                      onChange={(e) => {
                        setWatermarkTime(e.target.checked);
                      }}
                    >
                      核查时间
                    </Checkbox>
                    <Checkbox
                      checked={watermarkSystemTime}
                      onChange={(e) => {
                        setWatermarkSystemTime(e.target.checked);
                      }}
                    >
                      电脑系统时间
                    </Checkbox>
                    <div className="verifierBox">
                      <Checkbox
                        checked={watermarkVerifier}
                        onChange={(e) => {
                          setWatermarkVerifier(e.target.checked);
                        }}
                      >
                        核查人
                      </Checkbox>
                      <Input
                        placeholder="请输入核查人"
                        style={{ width: "140px" }}
                        size="small"
                        value={watermarkVerifierText}
                        onChange={(e) => {
                          setWatermarkVerifierText(e.target.value);
                        }}
                        disabled={!watermarkVerifier}
                      ></Input>
                    </div>
                  </div>
                </div>
                <div className="ruleItem">
                  <div className="ruleItemTitle">是否核查曾用名</div>
                  <div className="ruleItemBox">
                    <Radio.Group
                      name="verifyPreviousNames"
                      value={verifyPreviousNames}
                      onChange={(e) => {
                        setVerifyPreviousNames(e.target.value);
                      }}
                      options={[
                        { value: 1, label: "是" },
                        { value: 2, label: "否" },
                      ]}
                    />
                  </div>
                </div>
                <div className="ruleItem">
                  <div className="ruleItemTitle">报告中如何展示截图</div>
                  <div className="ruleItemBox">
                    <Radio.Group
                      name="reportScreenshotDisplayType"
                      value={reportScreenshotDisplayType}
                      onChange={(e) => {
                        setReportScreenshotDisplayType(e.target.value);
                      }}
                      options={[
                        { value: 1, label: "直接插入图片" },
                        { value: 2, label: "仅插入图片链接" },
                      ]}
                    />
                  </div>
                </div>
                <div className="ruleItem">
                  <div className="ruleItemTitle">
                    是否自动补充吾道数据库已有数据
                  </div>
                  <div className="ruleItemBox">
                    <Radio.Group
                      name="automaticReplenishment"
                      value={automaticReplenishment}
                      onChange={(e) => {
                        setAutomaticReplenishment(e.target.value);
                      }}
                      options={[
                        { value: 1, label: "是" },
                        { value: 2, label: "否" },
                      ]}
                    />
                  </div>

                  <span className="tipsSpan">
                    根据吾道全量爬虫数据，补充核查时网页没有检索到的数据
                  </span>
                </div>
                {previewPath && (
                  <div className="ruleItem screenshotExample">
                    <div className="ruleItemTitle screenshotTitle">核查截图示例</div>
                    <div className="ruleItemBox">
                      <div
                        className="previewImageBox"
                        onClick={() => {
                          Modal.confirm({
                            icon: null,
                            width: 800,
                            style: { top: 20 },
                            content: (
                              <img
                                src={previewPath}
                                alt="核查截图示例"
                                style={{ width: "100%" }}
                              />
                            ),
                            footer: null,
                            closable: true,
                          });
                        }}
                      >
                        <img src={previewPath} alt="核查截图示例" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              {isScheduledTask && (
                <div class="headerTitleContent">
                  <div class="left">
                    <span class="block"></span>
                    <div class="title">
                      <div class="commentsHeaderTitleBox">核查时间</div>
                    </div>
                  </div>
                </div>
              )}
              {isScheduledTask && (
                <div className="stepContentBox">
                  <div className="ruleItem">
                    <div className="ruleItemTitle">核查任务类型</div>
                    <div className="ruleItemBox">
                      <Radio.Group
                        name="verificationType"
                        value={verificationType}
                        onChange={(e) => {
                          setVerificationType(e.target.value);
                        }}
                        options={[
                          { value: 1, label: "单次核查" },
                          { value: 2, label: "周期核查" },
                        ]}
                      />
                    </div>
                  </div>
                  {verificationType === 1 && (
                    <div className="ruleItem">
                      <div className="ruleItemTitle">核查时间</div>
                      <div className="ruleItemBox">
                        <DatePicker
                          disabledDate={(current) => {
                            // Can not select days before today and today
                            return current && current < dayjs().startOf("day");
                          }}
                          format="YYYY-MM-DD"
                          allowClear
                          style={{ width: 140 }}
                          value={
                            verifyTime2
                              ? dayjs(verifyTime2, "YYYY-MM-DD")
                              : null
                          }
                          onChange={verifyTimeHandleChange2}
                        />
                        <TimePicker
                          style={{ width: 90, marginLeft: "12px" }}
                          value={
                            checkIntervalTime
                              ? dayjs(checkIntervalTime, "HH:mm")
                              : null
                          }
                          onChange={(a, b) => {
                            setCheckIntervalTime(b);
                          }}
                          allowClear={false}
                          format="HH:mm"
                        />
                      </div>
                    </div>
                  )}
                  {verificationType === 2 && (
                    <div className="ruleItem">
                      <div className="ruleItemTitle">核查时间</div>
                      <div className="ruleItemBox">
                        <RangePicker
                          style={{ width: 250 }}
                          allowClear
                          disabledDate={(current) => {
                            // Can not select days before today and today
                            return current && current < dayjs().startOf("day");
                          }}
                          format="YYYY-MM-DD"
                          value={verifyTime?.map((_) =>
                            _ ? dayjs(_, "YYYY-MM-DD") : null
                          )}
                          onChange={verifyTimeHandleChange}
                        />
                      </div>
                    </div>
                  )}
                  {verificationType === 2 && (
                    <div className="ruleItem">
                      <div className="ruleItemTitle">核查周期</div>
                      <div className="ruleItemBox">
                        <Select
                          style={{ width: 70 }}
                          onChange={(value) => {
                            setCheckIntervalIndex(1);
                            setCheckInterval(value);
                          }}
                          value={checkInterval}
                          options={[
                            { value: "moon", label: "每月" },
                            { value: "week", label: "每周" },
                          ]}
                        />
                        <Select
                          suffixIcon={<CalendarOutlined />}
                          style={{ width: 80, marginLeft: "12px" }}
                          value={checkIntervalIndex}
                          onChange={(value) => {
                            setCheckIntervalIndex(value);
                          }}
                          options={
                            checkInterval === "moon" ? moonOptions : weekOptions
                          }
                        />
                        <TimePicker
                          style={{ width: 90, marginLeft: "12px" }}
                          value={
                            checkIntervalTime
                              ? dayjs(checkIntervalTime, "HH:mm")
                              : null
                          }
                          onChange={(a, b) => {
                            setCheckIntervalTime(b);
                          }}
                          allowClear={false}
                          format="HH:mm"
                        />
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <Modal
        title="新增常用"
        centered={true}
        open={isAddModalOpen}
        onOk={addFrequentlyWebsiteHandle}
        onCancel={() => {
          setIsAddModalOpen(false);
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <span>分组名称</span>
          <Input
            allowClear
            placeholder="请输入分组名称"
            style={{ width: "390px", marginLeft: "20px" }}
            value={frequentlyWebsiteGroupName}
            onChange={(e) => {
              setFrequentlyWebsiteGroupName(e.target.value);
            }}
          ></Input>
        </div>
      </Modal>
    </Drawer>
  );
};
export default CreateDrawer;
